export const env = (key: string) => {
  const value = process.env['REACT_APP_' + key]

  return value ? value : ''
}
